import PropTypes from 'prop-types'

/**
 * @typedef {Object} IntlConfig
 * @property {DateFormatOptions} dateFormatOptions - Dictionary with predefined option sets for Intl based date formatting
 * @property {string} distUnit - The desired distance unit e.g. km or mi
 * @property {string} energyEfficiencyUnit - The desired energy efficiency unit
 * @property {string} fuelEfficiencyUnit - The desired fuel efficiency unit
 * @property {NumberFormatOptions} numberFormatOptions - Dictionary with predefined option sets for Intl based number formatting
 * @property {Object} translations - The translation dictionary to be used
 */
export const intlConfigPropType = PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    dateFormatOptions: PropTypes.object,
    distUnit: PropTypes.string,
    energyEfficiencyUnit: PropTypes.string,
    fuelEfficiencyUnit: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    numberFormatOptions: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    translations: PropTypes.object
})
